/**
 * @name logout
 * @param oktaAuth object provided by the Okta SDK
 * @desc Logs the user out from Okta session
 */
const logout = async oktaAuth => {
  if (!oktaAuth) return;

  localStorage.clear();
  await oktaAuth.closeSession();
  await oktaAuth.revokeAccessToken();

  window.location.reload();
};

export default logout;
